import {useMutation} from 'react-query';
import {countriesService} from '../../../../shared/services/configuration/countries';
import { ICreateCountry } from '../../../../shared/services/configuration/countries/dtos/create-country';
import { useNavigate } from 'react-router-dom';

export const useCreateCountry = () => {
   const navigate = useNavigate();
  return useMutation(
    async (payload: ICreateCountry) => {
      return await countriesService.createCountry(payload);
    },
    {
      onSuccess: () => navigate('/configuration/countries'),
    },
  );
};
